/**
 * Countdown Promo - Live countdown timer for time-limited offers
 * Handles countdown logic, expiration, and updates
 */
(function ($) {
    function init() {
        $('.js-countdown').each(function () {
            const $timer = $(this);
            
            // Skip if already initialized
            if ($timer.data('countdown-initialized')) return;
            $timer.data('countdown-initialized', true);

            const endTime = parseInt($timer.data('end'), 10);
            const $section = $timer.closest('.countdown-promo');
            const expiredMessage = $section.data('expired-message') || 'This offer has ended';

            const $days = $timer.find('.js-countdown-days');
            const $hours = $timer.find('.js-countdown-hours');
            const $minutes = $timer.find('.js-countdown-minutes');
            const $seconds = $timer.find('.js-countdown-seconds');

            let intervalId = null;

            function padZero(num) {
                return num < 10 ? '0' + num : String(num);
            }

            function updateCountdown() {
                const now = Date.now();
                const diff = endTime - now;

                if (diff <= 0) {
                    // Timer expired
                    clearInterval(intervalId);
                    handleExpired();
                    return;
                }

                const totalSeconds = Math.floor(diff / 1000);
                const days = Math.floor(totalSeconds / 86400);
                const hours = Math.floor((totalSeconds % 86400) / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;

                $days.text(padZero(days));
                $hours.text(padZero(hours));
                $minutes.text(padZero(minutes));
                $seconds.text(padZero(seconds));
            }

            function handleExpired() {
                $section.addClass('countdown-promo--expired');

                // Create and show expired message if it doesn't exist
                if (!$section.find('.countdown-promo__expired-message').length) {
                    const $expiredEl = $('<p class="countdown-promo__expired-message"></p>')
                        .text(expiredMessage);
                    $timer.after($expiredEl);
                }

                $timer.hide();

                // P2-5: countdown_expired event
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({
                        event:      'countdown_expired',
                        promo_name: $section.data('promo-name') || '',
                    });
                }
            }

            // Initial update
            updateCountdown();

            // Update every second
            intervalId = setInterval(updateCountdown, 1000);

            // P2-5: countdown_cta_click event
            $section.find('.countdown-promo__cta').on('click', function () {
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({
                        event:       'countdown_cta_click',
                        promo_name:  $section.data('promo-name') || '',
                        destination: this.href || '',
                    });
                }
            });

            // Cleanup on page unload
            $(window).on('beforeunload', function () {
                clearInterval(intervalId);
            });
        });
    }

    // Initialize on document ready
    $(document).ready(init);
    
    // Re-initialize on AJAX content load (for flexible content, etc.)
    $(document).on('ajaxComplete', init);

})(jQuery);
